import React from "react";

interface CardInfoProps {
    icon: any;
    label: string;
    labelClass: string;
}

const CardInfo = ({label, labelClass, icon }: CardInfoProps) => {
    return (
            <div className={"flex justify-between items-center h-10 w-full"}>
                <div className={`text-2xl font-bold ${labelClass}`}>{label}</div>
                {icon}
            </div>
    );
};

export default CardInfo;
